/* unplugin-vue-components disabled */import { render } from "./FormRadioGroup.vue?vue&type=template&id=2b13a924&ts=true"
import script from "./FormRadioGroup.vue?vue&type=script&lang=ts"
export * from "./FormRadioGroup.vue?vue&type=script&lang=ts"

import "./FormRadioGroup.vue?vue&type=style&index=0&id=2b13a924&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__